export default __webpack_public_path__ + "static/media/02.cf825280.png";